/* eslint-disable @next/next/no-img-element */
import moment from "moment";
import Link from "next/link";
import Masonry from "react-masonry-css";
import styles from "./RecentArticles.module.scss";

const breakpointColumnsObj = {
  default: 4,
  1100: 3,
  700: 2,
  500: 1,
};

const RecentArticles = ({ items }) => {
  const url_format =
    "https://cdn.rycofilters.com/etc-squidex-assets/39f5cacb-bc68-4cc4-b4cd-4631fe4f2bcd";

  return (
    <div className='container'>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className={`${styles.myMasonryGrid} `}
        columnClassName={`${styles.myMasonryGrid__column} `}
      >
        {items.length > 0 &&
          items.map((article, idx) => {
            const item = article.flatData;
            const img =
              item?.coverImage != null ? item?.coverImage[0]?.url : "";
            const cdn = img;
            const dd = moment(article.created).format("Do MMM YY");

            return (
              <div className={`card ${styles.ArticleCard}`} key={idx}>
                <Link href={`/articles/${item.pageId}`} legacyBehavior>
                  <a>
                    <img
                      src={cdn}
                      className='img-fluid mx-auto'
                      alt=''
                      loading='lazy'
                    />
                    <div className='p-2'>
                      <p className={`${styles.title}`}>{item.heading}</p>
                      {item.subHeading && <p className=''>{item.subHeading}</p>}
                      <p>RYCO FILTERS - {dd}</p>
                      {item.keywords &&
                        item.keywords.map((x, idx1) => {
                          return (
                            <span
                              key={idx1}
                              className='badge rounded-pill bg-secondary'
                            >
                              #{x}
                            </span>
                          );
                        })}
                    </div>
                  </a>
                </Link>
              </div>
            );
          })}
      </Masonry>
    </div>
  );
};

export default RecentArticles;
